import React from "react";
import styles from "./scss/whileattach.module.scss";
import attachimg from "../../../styles/images/whileattach.svg";

type WhileAttachProps = { name: any; }
export default function WhileAttach({ name }:WhileAttachProps) {
  return (
    <>
      <div className={styles.chatattach}>
        <div className={styles.chatattachinner}>
          <img src={attachimg} alt=""/>
          <p>{ name }</p>
        </div>
      </div>
    </>
  );
};

